import { useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import { ExportService } from '@/services/import/ExportService';
import { toast } from 'sonner';

export function useStaticFeaturesExport() {
  const [isExporting, setIsExporting] = useState(false);

  const exportMutation = useMutation({
    mutationFn: async ({ providerId, versionId, providerName, versionNumber }: {
      providerId: number;
      versionId: number;
      providerName: string;
      versionNumber: string;
    }) => {
      setIsExporting(true);
      try {
        const exportData = await ExportService.exportStaticFeaturesData(providerId, versionId);
        const filename = ExportService.generateFilename(
          providerName, 
          versionNumber, 
          exportData.context.export_timestamp,
          'static'
        );
        ExportService.downloadJSON(exportData, filename);
        return { success: true, filename };
      } catch (error) {
        console.error('Static features export failed:', error);
        throw error;
      } finally {
        setIsExporting(false);
      }
    },
    onSuccess: (data) => {
      toast.success(`Successfully exported static data to ${data.filename}`);
    },
    onError: (error: any) => {
      toast.error(error?.message || "Failed to export provider static features data");
    },
  });

  const exportStaticFeatures = (providerId: number, versionId: number, providerName: string, versionNumber: string) => {
    exportMutation.mutate({ providerId, versionId, providerName, versionNumber });
  };

  return {
    exportStaticFeatures,
    isExporting,
    isLoading: exportMutation.status === 'pending',
    error: exportMutation.error,
  };
}